<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Unearned Revenue Report</h4>
                <p class="text-subtitle-1">Customers with balance and Open Agreements</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2" align="center">
            <v-col cols="12" md="3">
                <DatePicker
                    label="As of"
                    v-model="form.to"
                    dense
                    outlined
                    hide-details/>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block class="primary" @click="fetchAsync" :loading="loading">
                    <v-icon left>mdi-magnify</v-icon>
                    search
                </v-btn>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col>
                <v-text-field
                    label="Filter"
                    v-model="filter"
                    prepend-inner-icon="mdi-filter"
                    filled
                    single-line
                    dense
                    shaped
                    hide-details>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-checkbox v-model="hasOpenOrder" label="Hide Customers Without Agreements"></v-checkbox>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-progress-linear indeterminate v-if="loading"/>
                <v-simple-table
                    dense>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Customer</th>
                            <th>Balance</th>
                            <th>Price</th>
                            <th>Validity Date</th>
                            <th>Quantity</th>
                            <th>Delivered</th>
                            <th>Remaining</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, i) in filtered" :key="i">
                            <td>{{i + 1}}</td>
                            <td>
                                <v-btn icon small @click="openCustomerDialog(d)">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                                {{d.code}} - {{d.name}}
                            </td>
                            <td class="red--text">{{renderBalance(d.balance)}}</td>
                            <td>{{formatNumber(d.average_price)}}</td>
                            <td :class="{'red--text': isExpired(d.validity), 'font-weight-bold': isExpired(d.validity) }">{{d.validity}}</td>
                            <td>{{formatNumber(d.quantity)}}</td>
                            <td>{{formatNumber(d.poured)}}</td>
                            <td>{{formatNumber(d.quantity - d.poured)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Totals</th>
                            <th></th>
                            <th class="red--text">{{renderBalance(getTotal(filtered, "balance"))}}</th>
                            <th></th>
                            <th></th>
                            <th>{{formatNumber(getTotal(filtered, "quantity"))}}</th>
                            <th>{{formatNumber(getTotal(filtered, "poured"))}}</th>
                            <th>{{formatNumber(getTotal(filtered, "quantity") - getTotal(filtered, "poured"))}}</th>
                        </tr>
                    </tfoot>
                </v-simple-table>
            </v-col>
        </v-row>
        <CustomerDisplayDialog ref="customerDisplayDialog"/>
    </div>
</template>

<script>
import reportAPI from './../../services/sales/reports'
import { formatNumber } from 'accounting'
import DatePicker from './../../components/common/DatePicker.vue'
import moment from 'moment'
import CustomerDisplayDialog from './../../components/Sales/CustomerDisplayDialog';
import { getTotal } from './../../utils/accounting';

export default {
    components: {
        DatePicker,
        CustomerDisplayDialog
    },
    data() {
        return {
            data: [],
            loading: false,
            form: {
                to: moment().endOf("year").format("YYYY-MM-DD")
            },
            filter: "",
            hasOpenOrder: true
        }
    },
    computed: {
        filtered() {
            let data = this.data;
            if(this.filter || this.filter !== "") {
                data = data.filter(each => each.name.toLowerCase().indexOf(this.filter.toLowerCase()) != -1 || each.code.toLowerCase().indexOf(this.filter.toLowerCase()) != -1)     
            }
            if(this.hasOpenOrder) data = data.filter(each => each.validity)
            return data
        }
    },
    methods: {
        getTotal,
        fetchAsync() {
            this.data = [];
            this.loading = true;
            reportAPI.unearnedRevenue(this.form).then(response => {
                this.data = response.data
            }).finally(() => {
                this.loading = false;
            })
        },
        isExpired(validity) {
            return moment(validity).isBefore(moment())
        },
        renderBalance(amount) {
            return `(${formatNumber(Math.abs(amount), 2)})`
        },
        formatNumber(n) {
            return formatNumber(n, 2)
        },
        openCustomerDialog(row) {
            this.$refs.customerDisplayDialog.open({ id: row.id });
        }
    },
    created() {
        this.fetchAsync();
    }
}
</script>

<style>

</style>